import { render } from "./geotargeting-incentive.vue?vue&type=template&id=ea93e1ec&ts=true"
import script from "./geotargeting-incentive.ts?vue&type=script&lang=ts&external"
export * from "./geotargeting-incentive.ts?vue&type=script&lang=ts&external"

import "./geotargeting-incentive.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__